import { render } from "./ErrorDisplay.vue?vue&type=template&id=be4c5ee2"
import script from "./ErrorDisplay.vue?vue&type=script&lang=js"
export * from "./ErrorDisplay.vue?vue&type=script&lang=js"
script.render = render

export default script